import script from "./Notes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notes.vue?vue&type=script&setup=true&lang=ts"

import "./Notes.vue?vue&type=style&index=0&id=e4f4f222&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4f4f222"]])

export default __exports__